import { Button, Modal } from "react-bootstrap";

interface IProps {
    show: boolean,
    onUpdate: () => void,
    onCancel: () => void
}

const UpdateMonthlyFeesModal = (props: IProps) => {
    return (
        <Modal bsSize='sm' show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                Update Monthly Fees?
            </Modal.Header>
            <Modal.Body>
                Please confirm that you want to update the monthly fees for all centers.
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onUpdate}>Update</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default UpdateMonthlyFeesModal;